/* global axios */

import Cookies from 'js-cookie';
import endPoints from './endPoints';
import {
  clearCookiesOnLogout,
  deleteIndexedDBOnLogout,
} from '../store/utils/api';

export default {
  validityCheck() {
    const urlData = endPoints('validityCheck');
    if (window.chatwootConfig?.isNativeApp) {
      return axios.get(urlData.url, { timeout: 8000 });
    }
    return axios.get(urlData.url);
  },
  async logout() {
    const urlData = endPoints('logout');
    try {
      await window.viperNativeAuth?.beforeLogout?.();
    } catch (error) {
      // A stale remote token is removed by the relay after Firebase reports it
      // as invalid. Do not prevent the user from ending their session.
      // eslint-disable-next-line no-console
      console.error('[ViperChat] Native push logout cleanup failed', error);
    }

    const response = await axios.delete(urlData.url);
    deleteIndexedDBOnLogout();
    clearCookiesOnLogout();
    return response;
  },
  hasAuthCookie() {
    return Boolean(
      window.viperNativeSession || Cookies.get('cw_d_session_info')
    );
  },
  getAuthData() {
    if (window.viperNativeSession) {
      return window.viperNativeSession;
    }

    if (this.hasAuthCookie()) {
      const savedAuthInfo = Cookies.get('cw_d_session_info');
      return JSON.parse(savedAuthInfo || '{}');
    }
    return false;
  },
  profileUpdate({
    displayName,
    avatar,
    custom_attributes: customAttributes,
    ...profileAttributes
  }) {
    const formData = new FormData();
    Object.keys(profileAttributes).forEach(key => {
      const hasValue = profileAttributes[key] === undefined;
      if (!hasValue) {
        formData.append(`profile[${key}]`, profileAttributes[key]);
      }
    });
    if (customAttributes) {
      Object.keys(customAttributes).forEach(key => {
        const value = customAttributes[key];
        if (value !== undefined) {
          formData.append(`profile[custom_attributes][${key}]`, value);
        }
      });
    }
    formData.append('profile[display_name]', displayName || '');
    if (avatar) {
      formData.append('profile[avatar]', avatar);
    }
    // eslint-disable-next-line no-console
    console.log('[AuthAPI] profileUpdate', {
      hasAvatar: !!avatar,
      customAttributesKeys: Object.keys(customAttributes || {}),
      hasWebrtcJwt: !!customAttributes?.webrtc_jwt,
      hasWebrtcUsername: !!customAttributes?.webrtc_username,
      hasWebrtcPassword: !!customAttributes?.webrtc_password,
    });
    return axios.put(endPoints('profileUpdate').url, formData);
  },

  profilePasswordUpdate({ currentPassword, password, passwordConfirmation }) {
    return axios.put(endPoints('profileUpdate').url, {
      profile: {
        current_password: currentPassword,
        password,
        password_confirmation: passwordConfirmation,
      },
    });
  },

  updateUISettings({ uiSettings }) {
    return axios.put(endPoints('profileUpdate').url, {
      profile: { ui_settings: uiSettings },
    });
  },

  updateAvailability(availabilityData) {
    return axios.post(endPoints('availabilityUpdate').url, {
      profile: { ...availabilityData },
    });
  },

  updateAutoOffline(accountId, autoOffline = false) {
    return axios.post(endPoints('autoOffline').url, {
      profile: { account_id: accountId, auto_offline: autoOffline },
    });
  },

  deleteAvatar() {
    return axios.delete(endPoints('deleteAvatar').url);
  },

  resetPassword({ email }) {
    const urlData = endPoints('resetPassword');
    return axios.post(urlData.url, { email });
  },

  setActiveAccount({ accountId }) {
    const urlData = endPoints('setActiveAccount');
    return axios.put(urlData.url, {
      profile: {
        account_id: accountId,
      },
    });
  },
  resendConfirmation() {
    const urlData = endPoints('resendConfirmation');
    return axios.post(urlData.url);
  },
  resetAccessToken() {
    const urlData = endPoints('resetAccessToken');
    return axios.post(urlData.url);
  },
  getSessions() {
    return axios.get('/api/v1/profile/sessions');
  },
  revokeSession(id) {
    return axios.delete(`/api/v1/profile/sessions/${id}`);
  },
};
